import { ComponentPortal } from '@angular/cdk/portal'
import { Directive } from '@angular/core'
import { TooltipDirective } from '../tooltip.directive'
import { TooltipUnpaddedComponent } from './tooltip.unpadded.component'

@Directive({
  selector: '[ftrTooltipUnpadded]',
  exportAs: 'ftrTooltipUnpadded',
})
export class TooltipUnpaddedDirective extends TooltipDirective {
  override setPortal(): void {
    this.portal = this.portal || new ComponentPortal(TooltipUnpaddedComponent)
  }
}
